// composeApp/src/jsMain/kotlin/dk/smark/demo/auth/CredentialsStorage.js.kt
package dk.smark.demo.auth

import kotlinx.browser.localStorage

actual fun createCredentialsStorage(): CredentialsStorage = JsCredentialsStorage()

class JsCredentialsStorage : CredentialsStorage {
    override fun save(email: String, password: String) {
        localStorage.setItem("email", email)
        localStorage.setItem("password", password)
    }

    override fun load(): SavedCredentials? {
        val email = localStorage.getItem("email") ?: return null
        val password = localStorage.getItem("password") ?: return null
        return SavedCredentials(email, password)
    }

    override fun clear() {
        localStorage.removeItem("email")
        localStorage.removeItem("password")
    }
}